// Font banera se bira po baneru u adminu (HeroSlider, samo na naslovnoj).
// Ranije je index.html ucitavao svih sest familija na svakoj stranici — 51 KB
// samo CSS-a plus fajlovi fontova, i tamo gde banera uopste nema. Sada se
// povlaci iskljucivo familija koju banner stvarno trazi.

// Ostale familije iz admin izbornika idu na 400;600;700.
const WEIGHTS: Record<string, string> = { Roboto: '400;500;700' };

const requested = new Set<string>();

export const ensureBannerFont = (family?: string | null): void => {
  if (!family || requested.has(family)) return;
  requested.add(family);
  const weights = WEIGHTS[family] || '400;600;700';
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href =
    `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, '+')}` +
    `:wght@${weights}&display=swap`;
  document.head.appendChild(link);
};
